import { render, staticRenderFns } from "./CurtainBushPassport.vue?vue&type=template&id=40722d2f&scoped=true"
import script from "./CurtainBushPassport.vue?vue&type=script&lang=js"
export * from "./CurtainBushPassport.vue?vue&type=script&lang=js"
import style0 from "./CurtainBushPassport.vue?vue&type=style&index=0&id=40722d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40722d2f",
  null
  
)

export default component.exports